<template>
  <auth-shell>
    <p class="auth-form__eyebrow">
      Recupera tu acceso
    </p>
    <h1 class="auth-form__title auth-form__title--with-lead">
      ¿Olvidaste tu contraseña?
    </h1>
    <p class="auth-form__lead">
      Escribe tu correo y te enviaremos un enlace para crear una contraseña nueva.
    </p>

    <validation-observer
      ref="simpleRules"
      #default="{ invalid }"
    >
      <b-form
        class="auth-form__fields"
        @submit.prevent="validationForm"
      >
        <validation-provider
          #default="{ errors }"
          tag="div"
          name="Correo electrónico"
          rules="required|email"
        >
          <label
            class="sr-only"
            for="forgot-password-email"
          >Correo electrónico</label>
          <b-input-group :class="['auth-input', { 'auth-input--invalid': errors.length }]">
            <b-input-group-prepend is-text>
              <feather-icon icon="MailIcon" />
            </b-input-group-prepend>
            <b-form-input
              id="forgot-password-email"
              v-model="userEmail"
              type="email"
              autocomplete="email"
              placeholder="Correo electrónico"
            />
          </b-input-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>

        <b-button
          type="submit"
          class="auth-submit"
          block
          :disabled="invalid || isSubmitting"
        >
          <b-spinner
            v-if="isSubmitting"
            small
          />
          <template v-else>
            <span>Enviar enlace</span>
            <feather-icon
              icon="SendIcon"
              size="16"
            />
          </template>
        </b-button>
      </b-form>
    </validation-observer>

    <p class="auth-form__back">
      <b-link :to="{ name: 'auth-login' }">
        <feather-icon icon="ChevronLeftIcon" />
        Volver a iniciar sesión
      </b-link>
    </p>
  </auth-shell>
</template>

<script>
import { mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BLink, BForm, BFormInput, BInputGroup, BInputGroupPrepend, BButton, BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AuthShell from '@/components/auth/AuthShell.vue'

export default {
  components: {
    AuthShell,
    BLink,
    BForm,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      isSubmitting: false,
      required,
      email,
    }
  },
  methods: {
    ...mapActions('auth', ['requestPassword']),
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (!success || this.isSubmitting) return

        this.isSubmitting = true
        this.requestPassword({ email: this.userEmail })
          .then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Te enviamos un correo',
                text: 'Revisa tu bandeja para crear tu contraseña nueva.',
                icon: 'MailIcon',
                variant: 'success',
              },
            })
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'No pudimos enviar el correo',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                text: error?.response?.data?.messages?.[0],
              },
            })
          })
          .finally(() => {
            this.isSubmitting = false
          })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../components/auth/auth-page.scss';
</style>
